import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { VerticalAlignment, Alignment } from '@teko-builder/types/shared';
import { fontQueryParams } from './fonts.es.js';
import { Helmet } from 'react-helmet';
import 'tslib';
import '@teko-builder/types/pb';
import { t as themeColor } from './text-21866551.js';
import { g as getRgbaFromHex } from './util-80df897f.js';
import 'ua-parser-js';
import 'color-name';
import '@emotion/react';

const reset = `
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
      'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  [tabindex='-1']:focus:not(:focus-visible) {
    outline: 0 !important;
  }

  hr {
    margin: 1rem 0;
    color: inherit;
    background-color: currentColor;
    border: 0;
    opacity: 0.25;
  }

  hr:not([size]) {
    height: 1px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.3;
    color: unset;
  }

  h1 {
    font-size: calc(1.375rem + 1.5vw);
  }

  @media (min-width: 1200px) {
    h1 {
      font-size: 2.5rem;
    }
  }

  h2 {
    font-size: calc(1.325rem + 0.9vw);
  }

  @media (min-width: 1200px) {
    h2 {
      font-size: 2rem;
    }
  }

  h3 {
    font-size: calc(1.3rem + 0.6vw);
  }

  @media (min-width: 1200px) {
    h3 {
      font-size: 1.75rem;
    }
  }

  h4 {
    font-size: calc(1.275rem + 0.3vw);
  }

  @media (min-width: 1200px) {
    h4 {
      font-size: 1.5rem;
    }
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  abbr[title],
  abbr[data-original-title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    -webkit-text-decoration-skip-ink: none;
    text-decoration-skip-ink: none;
  }

  address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
  }

  ol,
  ul {
    padding-left: 2rem;
  }

  ol,
  ul,
  dl {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  ol ol,
  ul ul,
  ol ul,
  ul ol {
    margin-bottom: 0;
  }

  dt {
    font-weight: 700;
  }

  dd {
    margin-bottom: 0.5rem;
    margin-left: 0;
  }

  blockquote {
    margin: 0 0 1rem;
  }

  b,
  strong {
    font-weight: bolder;
  }

  small {
    font-size: 0.875em;
  }

  mark {
    padding: 0.2em;
    background-color: #fcf8e3;
  }

  sub,
  sup {
    position: relative;
    font-size: 0.75em;
    line-height: 0;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  a {
    color: #0d6efd;
    text-decoration: none;
  }

  a:hover {
    color: #024dbc;
  }

  a:not([href]),
  a:not([href]):hover {
    color: inherit;
    text-decoration: none;
  }

  pre,
  code,
  kbd,
  samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
      'Courier New', monospace;
    font-size: 1em;
  }

  pre {
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    font-size: 0.875em;
  }

  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal;
  }

  code {
    font-size: 0.875em;
    color: #d63384;
    word-wrap: break-word;
  }

  a > code {
    color: inherit;
  }

  kbd {
    padding: 0.2rem 0.4rem;
    font-size: 0.875em;
    color: #fff;
    background-color: #212529;
    border-radius: 0.2rem;
  }

  kbd kbd {
    padding: 0;
    font-size: 1em;
    font-weight: 700;
  }

  figure {
    margin: 0 0 1rem;
  }

  img,
  svg {
    vertical-align: middle;
  }

  table {
    caption-side: bottom;
    border-collapse: collapse;
  }

  caption {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    color: #6c757d;
    text-align: left;
  }

  th {
    text-align: inherit;
    text-align: -webkit-match-parent;
  }

  label {
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  button {
    border-radius: 0;
  }

  button:focus {
    outline: none;
  }

  input,
  button,
  select,
  optgroup,
  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  select {
    word-wrap: normal;
  }

  [list]::-webkit-calendar-picker-indicator {
    display: none;
  }

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  button:not(:disabled),
  [type='button']:not(:disabled),
  [type='reset']:not(:disabled),
  [type='submit']:not(:disabled) {
    cursor: pointer;
  }

  ::-moz-focus-inner {
    padding: 0;
    border-style: none;
  }

  input[type='date'],
  input[type='time'],
  input[type='datetime-local'],
  input[type='month'] {
    -webkit-appearance: textfield;
  }

  textarea {
    resize: vertical;
  }

  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }

  legend {
    float: left;
    width: 100%;
    padding: 0;
    margin-bottom: 0.5rem;
    font-size: calc(1.275rem + 0.3vw);
    line-height: inherit;
    white-space: normal;
  }

  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem;
    }
  }

  legend + * {
    clear: left;
  }

  ::-webkit-datetime-edit-fields-wrapper,
  ::-webkit-datetime-edit-text,
  ::-webkit-datetime-edit-minute,
  ::-webkit-datetime-edit-hour-field,
  ::-webkit-datetime-edit-day-field,
  ::-webkit-datetime-edit-month-field,
  ::-webkit-datetime-edit-year-field {
    padding: 0;
  }

  ::-webkit-inner-spin-button {
    height: auto;
  }

  [type='search'] {
    outline-offset: -2px;
    -webkit-appearance: textfield;
  }

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  ::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
  }

  output {
    display: inline-block;
  }

  summary {
    display: list-item;
    cursor: pointer;
  }

  progress {
    vertical-align: baseline;
  }

  [hidden] {
    display: none !important;
  }

  html,
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  span,
  em,
  small,
  strong,
  sub,
  sup,
  mark,
  del,
  ins,
  strike,
  abbr,
  dfn,
  blockquote,
  q,
  cite,
  code,
  pre,
  ol,
  ul,
  li,
  dl,
  dt,
  dd,
  div,
  section,
  article,
  main,
  aside,
  nav,
  header,
  hgroup,
  footer,
  img,
  figure,
  figcaption,
  address,
  time,
  audio,
  video,
  canvas,
  iframe,
  details,
  summary,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td {
    margin: 0;
    padding: 0;
    border: 0;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0px;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }
`;

const CORE_SIZE = {
    s0: '0rem',
    s4: '0.25rem',
    s8: '0.5rem',
    s12: '0.75rem',
    s16: '1rem',
    s20: '1.25rem',
    s24: '1.5rem',
    s28: '1.75rem',
    s32: '2rem',
    s36: '2.25rem',
    s40: '2.5rem',
    s44: '2.75rem',
    s48: '3rem',
    s52: '3.25rem',
    s56: '3.5rem',
    s60: '3.75rem',
    s64: '4rem',
    s68: '4.25rem',
    s72: '4.5rem',
    s76: '4.75rem',
    s80: '5rem',
};
const getBoxShadow = (props, shadow, shadowColor = 'black') => {
    const css = props.theme.shadowValue[shadow] || 'none';
    return css.replace(/{{color}}/gi, getRgbaFromHex(props.theme.colors[shadowColor], props.theme.shadowAlphaValue[shadow]));
};
const defaultTheme = {
    colors: themeColor,
    borderRadius: {
        s: CORE_SIZE.s4,
        m: CORE_SIZE.s8,
        l: CORE_SIZE.s12,
        xl: CORE_SIZE.s16,
    },
    borderWeight: {
        s: '0.5px',
        m: '1px',
        l: '1.5px',
    },
    opacity: {
        s: 0,
        m: 0.3,
        l: 0.5,
        xl: 0.7,
    },
    shadowValue: {
        'down-xs': '0 2px 2px {{color}}',
        'down-s': '0 2px 4px {{color}}',
        'down-m': '0 4px 8px {{color}}',
        'down-l': '0 4px 16px {{color}}, 0 8px 16px {{color}}',
        'up-s': '0 -2px 4px {{color}}',
        'up-m': '0 -4px 8px {{color}}',
        'up-l': '0px -4px 16px {{color}}, 0px -8px 16px {{color}};',
    },
    shadowAlphaValue: {
        'down-xs': 0.1,
        'down-s': 0.075,
        'down-m': 0.05,
        'down-l': 0.05,
        'up-s': 0.075,
        'up-m': 0.05,
        'up-l': 0.05,
    },
    spacing: CORE_SIZE,
    shadow: getBoxShadow,
};

const MAPPING_VERTICAL_ALIGNMENT_FLEX = {
    [VerticalAlignment.top]: 'flex-start',
    [VerticalAlignment.center]: 'center',
    [VerticalAlignment.bottom]: 'flex-end',
};
const MAPPING_ALIGNMENT_FLEX = {
    [Alignment.center]: 'center',
    [Alignment.left]: 'flex-start',
    [Alignment.right]: 'flex-end',
    [Alignment.justify]: 'space-between',
};
const MAX_WIDTH = 1232;
const landingLinks = [
    {
        rel: 'preconnect',
        href: 'https://fonts.googleapis.com',
    },
    {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
        crossOrigin: 'true',
    },
    {
        rel: 'stylesheet',
        href: `https://fonts.googleapis.com/css2?${fontQueryParams}&display=swap`,
    },
    {
        rel: 'stylesheet',
        href: 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css',
    },
];
const LandingLinks = () => (jsx(Helmet, { children: landingLinks.map((link, index) => (createElement("link", Object.assign({}, link, { key: index })))) }));

export { CORE_SIZE, LandingLinks, MAPPING_ALIGNMENT_FLEX, MAPPING_VERTICAL_ALIGNMENT_FLEX, MAX_WIDTH, defaultTheme, landingLinks, reset };
